export default __webpack_public_path__ + "static/MD_SearchThumb_Cloud-81af54605ba79a4548e34d9217fa10f6.webp";